import React from "react";
import { Plus, Minus } from "lucide-react";

interface QuestionsDistributionSectionProps {
  objetivas: number;
  dissertativas: number;
  onObjetivasChange: (value: number) => void;
  onDissertativasChange: (value: number) => void;
}

export const QuestionsDistributionSection: React.FC<
  QuestionsDistributionSectionProps
> = ({
  objetivas,
  dissertativas,
  onObjetivasChange,
  onDissertativasChange,
}) => {
  const handleDecrement = (current: number) => Math.max(0, current - 1);
  const handleIncrement = (current: number) => current + 1;

  return (
    <div className="col-span-full bg-(--card-bg) border border-(--border-color) rounded-2xl p-6 shadow-sm mb-2">
      <label className="block text-xs font-bold uppercase tracking-wider mb-6 text-(--text-tertiary)">
        Distribuição de Questões
      </label>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 sm:gap-12">
        <div className="flex flex-col items-center gap-5 p-4 rounded-xl bg-(--bg-secondary) border border-transparent transition-all hover:border-(--border-color)">
          <div className="text-center">
            <p className="text-[11px] sm:text-xs mb-2 font-bold uppercase tracking-widest text-(--text-tertiary)">
              Objetivas
            </p>
            <div
              className="text-4xl sm:text-5xl font-black transition-all"
              style={{
                color: "var(--primary-color)",
              }}
            >
              {objetivas}
            </div>
          </div>

          <div className="flex items-center gap-3">
            <button
              onClick={() => onObjetivasChange(handleDecrement(objetivas))}
              className="w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center transition-all hover:bg-red-50 hover:text-red-500 bg-white border border-(--border-color) shadow-sm active:scale-95 text-(--text-secondary)"
              title="Diminuir"
            >
              <Minus className="transition-transform group-hover:scale-110" />
            </button>
            <input
              type="number"
              min="0"
              max="50"
              value={objetivas}
              onChange={(e) =>
                onObjetivasChange(parseInt(e.target.value, 10) || 0)
              }
              className="w-14 sm:w-16 px-2 py-2 rounded-lg border-2 border-transparent text-center font-black text-lg sm:text-xl outline-none focus:border-blue-500 bg-transparent text-(--text-primary)"
            />
            <button
              onClick={() => onObjetivasChange(handleIncrement(objetivas))}
              className="w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center transition-all hover:bg-blue-50 hover:text-(--primary-color) bg-white border border-(--border-color) shadow-sm active:scale-95 text-(--text-secondary)"
              title="Aumentar"
            >
              <Plus className="transition-transform group-hover:scale-110" />
            </button>
          </div>
        </div>

        <div className="flex flex-col items-center gap-5 p-4 rounded-xl bg-(--bg-secondary) border border-transparent transition-all hover:border-(--border-color)">
          <div className="text-center">
            <p className="text-[11px] sm:text-xs mb-2 font-bold uppercase tracking-widest text-(--text-tertiary)">
              Dissertativas
            </p>
            <div
              className="text-4xl sm:text-5xl font-black transition-all"
              style={{
                color: "var(--primary-color)",
              }}
            >
              {dissertativas}
            </div>
          </div>

          <div className="flex items-center gap-3">
            <button
              onClick={() =>
                onDissertativasChange(handleDecrement(dissertativas))
              }
              className="w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center transition-all hover:bg-red-50 hover:text-red-500 bg-white border border-(--border-color) shadow-sm active:scale-95 text-(--text-secondary)"
              title="Diminuir"
            >
              <Minus className="transition-transform group-hover:scale-110" />
            </button>
            <input
              type="number"
              min="0"
              max="50"
              value={dissertativas}
              onChange={(e) =>
                onDissertativasChange(parseInt(e.target.value, 10) || 0)
              }
              className="w-14 sm:w-16 px-2 py-2 rounded-lg border-2 border-transparent text-center font-black text-lg sm:text-xl outline-none focus:border-blue-500 bg-transparent text-(--text-primary)"
            />
            <button
              onClick={() =>
                onDissertativasChange(handleIncrement(dissertativas))
              }
              className="w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center transition-all hover:bg-blue-50 hover:text-(--primary-color) bg-white border border-(--border-color) shadow-sm active:scale-95 text-(--text-secondary)"
              title="Aumentar"
            >
              <Plus className="transition-transform group-hover:scale-110" />
            </button>
          </div>
        </div>
      </div>

      <div className="mt-8 text-center p-4 rounded-xl bg-blue-50/50 border border-blue-100 flex items-center justify-center gap-3">
        <div className="w-8 h-8 rounded-full bg-(--primary-color) text-white flex items-center justify-center font-black text-sm">
          {objetivas + dissertativas}
        </div>
        <p className="text-sm font-bold text-(--text-secondary)">
          Total de questões planejadas
        </p>
      </div>
    </div>
  );
};
